module.exports = __webpack_public_path__ + "img/gggl2.15893bfb.png";